const styles = theme => ({
    main: {
        backgroundColor: "#353b48",
        color: "white",
        textAlign: "center",
        padding: 25,
        margin: "auto"
    },

    board: {
        margin: 20,
        width: "20%",
    },

    button: {
        margin: "auto",
        width: "10%",
    }
})

export default styles;
